import useFetchObjects from "../../api/useFetchObjects";

const useSearchBooks = (query, format = "PDF", limit = 5) => {
  const queryParams = new URLSearchParams();

  if (query) {
    queryParams.append("search", query);
  }
  if (limit) {
    queryParams.append("page_size", limit);
  }

  // Determine the endpoint based on format
  const endpoint =
    format === "Audiobook"
      ? "books/audio_books"
      : format === "Free"
      ? "books/free_books"
      : "books";

  return useFetchObjects(
    ["books", format, "search", query],
    `${endpoint}/?${queryParams.toString()}`,
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
      enabled: !!query, // Only fetch when there's a query
    },
  );
};

export default useSearchBooks;
